import script from "./index-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./index-page.vue?vue&type=script&setup=true&lang=ts"

import "./index-page.vue?vue&type=style&index=0&id=26ee4db6&lang=css"
import "./index-page.vue?vue&type=style&index=1&id=26ee4db6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ee4db6"]])

export default __exports__